import * as React from "react";
import {
  TextField,
  InputAdornment,
  Box,
  Grid,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import cx from "classnames";
import { SvgIcon } from "../../../../components";
import { tl } from "../../../../utils";
import * as styles from "./styles.scss";
import { themeVariables, Theme as theme } from "../_Theme";
import "moment/locale/ru";
import * as moment from "moment";
moment.locale("ru");
import { DateRangePicker } from "./dateRangePicker";

interface IProps {
  dateStart?: string;
  dateEnd?: string;
  onChange: (date1: Date, date2: Date) => void;
  disablePast?: boolean;
}

let firstTime = true;

export const MUIDatePickerRange = (props: IProps) => {
  const initialDateRange = {
    startDate: props.dateStart
      ? new Date(props.dateStart)
      : moment(new Date())
          .subtract(1, "days")
          .toDate(),
    endDate: props.dateEnd ? new Date(props.dateEnd) : new Date(),
  };
  const [dateRange, setDateRange] = React.useState(
    props.dateStart ? initialDateRange : null
  );
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const handleAccept = (startDate: any, endDate: any) => {
    setIsModalOpen(false);
    setDateRange({
      startDate,
      endDate,
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleClear = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setDateRange(null);
  };

  let saveTO: ReturnType<typeof setTimeout>;
  React.useEffect(() => {
    if (firstTime) {
      firstTime = false;
      return;
    }
    clearTimeout(saveTO);
    saveTO = setTimeout(() => {
      props.onChange(
        dateRange ? dateRange.startDate : null,
        dateRange ? dateRange.endDate : null
      );
    }, 500);
  }, [dateRange]);

  const classes = makeStyles({
    dateIcons: {
      marginBottom: "-32px",
      padding: themeVariables.spacing * 0.6 + "px !important",
      cursor: "pointer",
      [themeVariables.breakpoints.down("sm")]: {
        marginBottom: "-40px",
        padding: themeVariables.spacing * 1.1 + "px !important",
      },
    },
    datePicker: {
      backgroundColor: themeVariables.palette.grey.A100,
      border: themeVariables.border,
      borderLeft: "none",
      borderRadius: themeVariables.spacing * 0.25,
    },
  })({});
  return (
    <>
      <Box clone bgcolor={themeVariables.palette.common.white}>
        <TextField
          value={
            dateRange
              ? `${dateRange.startDate.toLocaleDateString()}${
                  dateRange.endDate
                    ? " - " + dateRange.endDate.toLocaleDateString()
                    : ""
                }`
              : ""
          }
          onClick={() => setIsModalOpen(true)}
          className={styles.dtPicker}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IconButton
                  title={tl(`Выбрать`)}
                  className={cx(classes.dateIcons, classes.datePicker)}
                  onClick={() => setIsModalOpen(true)}
                >
                  <SvgIcon type={"datepicker"} />
                </IconButton>
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  id="clearDateRange"
                  title={tl(`Очистить`)}
                  className={classes.dateIcons}
                  onClick={handleClear}
                >
                  <SvgIcon type={"search-clear"} />
                </IconButton>
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />
      </Box>
      {isModalOpen ? (
        <DateRangePicker
          title="Change date"
          initialDateRange={dateRange ? dateRange : initialDateRange}
          open={isModalOpen}
          onAccept={handleAccept}
          onCancel={handleCancel}
          //maxDate={initialDateRange.endDate}
          maxDate={moment(initialDateRange.endDate)
            .add(2, "years")
            .toDate()}
          minDate={moment(initialDateRange.startDate)
            .subtract(2, "years")
            .toDate()}
          dateStringFormatter="DD/MM/YYYY"
        />
      ) : null}
    </>
  );
};
